import React, {useEffect, useState} from 'react';
import {EventTypeImageRequestParams} from "../../../domain/common/events/models/event-type.image-request-params";
import DefaultIcon from './icons/default.svg';
import {WithDevice} from "../composers/with-device";

export const EventIconComposer = (EntityLogo) => WithDevice((props) => {
  const ratio = 1;
  const [src, setSrc] = useState(null);
  const onError = (e) => {
    setSrc(DefaultIcon);
  };

  useEffect(() => {
    const logoParams: EventTypeImageRequestParams = new props.event.iconType(props.event, props.width, props.height, ratio);
    setSrc(logoParams);
  }, [props.event]);

  return src === null ? null : <EntityLogo {...props} src={src} onError={onError}/>;
});
